import React from 'react';
import { CheckCircle, Download, MonitorSmartphone, Printer, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="bg-gradient-to-b from-sky-100 via-sky-50 to-white text-slate-900 pt-10 pb-10 px-4 relative overflow-hidden" data-id="element-63">
      {/* Background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-sky-300/30 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-64"></div>

      <div className="max-w-5xl mx-auto text-center z-10 relative" data-id="element-65">
        <h1 className="text-3xl md:text-6xl font-black leading-tight mb-6 uppercase tracking-tight text-slate-900" data-id="element-66">
          MANUAL ACADÉMICO DE <span className="text-sky-600" data-id="element-67">GEOGRAFÍA</span>{' '}
          PARA DOCENTES
        </h1>

        <div className="max-w-3xl mx-auto mb-6 relative" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/eDAuKwqjoGqFCaVaZNU71o/Diseno_sin_titulo_(10).png" alt="Manual Académico de Geografía" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-69" />
          {/* Guarantee Badge */}
          <div className="absolute -bottom-4 -right-2 md:bottom-4 md:-right-8 bg-green-500 text-white font-black p-3 rounded-full w-24 h-24 md:w-28 md:h-28 flex flex-col items-center justify-center transform rotate-12 shadow-xl border-4 border-white" data-id="element-70">
            <ShieldCheck size={24} className="mb-1" data-id="element-71" />
            <span className="text-center leading-tight text-xs" data-id="element-72">
              GARANTÍA
              <br data-id="element-73" />7 DÍAS
            </span>
          </div>
        </div>

        <h2 className="text-xl md:text-3xl font-bold mb-4 text-slate-700" data-id="element-74">
          para docentes de geografía de secundaria
        </h2>

        <p className="text-base md:text-xl font-medium mb-8 max-w-3xl mx-auto leading-relaxed text-slate-700" data-id="element-75">
          Clases, actividades, diapositivas, evaluaciones, trabajos practicos,
          teoria resumida y planificaciones: todo el mateial completo de 1° a 6°
          año en un solo lugar.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-xs md:text-sm font-semibold" data-id="element-76">
          <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-full border border-sky-200 shadow-sm" data-id="element-77">
            <Download className="text-green-500" size={16} data-id="element-78" />
            <span data-id="element-79">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-full border border-sky-200 shadow-sm" data-id="element-80">
            <CheckCircle className="text-green-500" size={16} data-id="element-81" />
            <span data-id="element-82">Acceso de por vida</span>
          </div>
          <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-full border border-sky-200 shadow-sm" data-id="element-83">
            <MonitorSmartphone className="text-green-500" size={16} data-id="element-84" />
            <span data-id="element-85">PDF</span>
          </div>
          <div className="flex items-center gap-2 bg-white px-3 py-2 rounded-full border border-sky-200 shadow-sm" data-id="element-86">
            <Printer className="text-green-500" size={16} data-id="element-87" />
            <span data-id="element-88">Material imprimible</span>
          </div>
        </div>
      </div>
    </section>;
}